// src/pages/home/HomePage.js
import React, { useState, useEffect } from "react";
import "./HomePage.css";

import LocationButton from "./LocationButton";
import AddDataButton from "./AddDataButton";
import DataModal from "./DataModal";
import CalendarLog from "./CalendarLog";
import DownloadExcelButton from "./DownloadExcelButton";
import DogLookup from "./DogLookup";
import UpdateDataButton from "./UpdateDataButton";

import logoDog from "../../assets/bideawee-logo.png";

function Homepage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const [location, setLocation] = useState(
    localStorage.getItem("selectedLocation")?.replace("In ", "") || "Foster"
  );

  // 🐶🐱 theme
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "dog");

  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  const handleLocationChange = (newLocation) => {
    localStorage.setItem("selectedLocation", newLocation);
    setLocation(newLocation.replace("In ", ""));
  };

  const isCat = theme === "cat";
  const headerLogo = logoDog;

  return (
    <div className={`homepage-wrapper ${isCat ? "cat-theme" : "dog-theme"}`}>
      {/* 🐾 Decorative Header */}
      <div className="decorative-header">
        <img src={headerLogo} alt="Bideawee Logo" className="header-logo" />
        <span className="decorative-header-text">
          {isCat ? "Cat Care Log" : "Walk / Activity Log"}
        </span>
      </div>

      {/* ✅ Two visible mode buttons */}
      <div className="theme-toggle-row">
        <button
          className={`theme-toggle ${!isCat ? "active" : ""}`}
          onClick={() => setTheme("dog")}
          aria-pressed={!isCat}
          type="button"
        >
          🐶 Dog Mode
        </button>

        <button
          className={`theme-toggle ${isCat ? "active" : ""}`}
          onClick={() => setTheme("cat")}
          aria-pressed={isCat}
          type="button"
        >
          🐱 Cat Mode
        </button>
      </div>

      <LocationButton onSelect={handleLocationChange} />
      <AddDataButton onClick={() => setIsModalOpen(true)} />

      <DogLookup
        location={location}
        theme={theme}
        refreshKey={refreshKey}
        mode={isCat ? "cat" : "dog"} // ✅ toggle-friendly
      />

      <CalendarLog
        refreshKey={refreshKey}
        location={location}
        mode={isCat ? "cat" : "dog"}
      />

      {isModalOpen && (
        <DataModal
          mode={isCat ? "cat" : "dog"}
          onClose={() => {
            setIsModalOpen(false);
            setRefreshKey((prev) => prev + 1);
          }}
        />
      )}

      <DownloadExcelButton />
      <UpdateDataButton />
    </div>
  );
}

export default Homepage;
